import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import api from '../../helpers/api_helper';

export interface RegisterPayload {
  mobile_number: string;
  first_name: string;
  last_name: string;
  grant_type: string; // 'password' | 'mpin' | others
  password: string;
  app_id: string;
  on_behalf_by: number;
}

export interface RegisterResult {
  message: string;
  user: {
    mobile_number: string;
    first_name: string;
    last_name: string;
    points: number;
  };
  tokens?: { access: string; refresh: string };
  requires_otp?: boolean;
}

interface RegistrationState {
  sending: boolean;
  error: string | null;
  lastResult: RegisterResult | null;
}

const initialState: RegistrationState = {
  sending: false,
  error: null,
  lastResult: null,
};

export const registerUser = createAsyncThunk(
  'registration/registerUser',
  async (payload: RegisterPayload, { rejectWithValue }) => {
    try {
      const res = await api.post<RegisterResult>('/users/register/', payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      return res.data;
    } catch (e: any) {
      // Pass the full error response data so we can access mobile_number and other field errors
      return rejectWithValue(e?.response?.data || { detail: e?.message || 'Registration failed' });
    }
  }
);

const slice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    clearRegistrationResult(state) {
      state.lastResult = null;
      state.error = null;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(registerUser.pending, (state) => {
        state.sending = true;
        state.error = null;
        state.lastResult = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.sending = false;
        state.lastResult = action.payload;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.sending = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearRegistrationResult } = slice.actions;
export default slice.reducer;


